/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Error_UnavailableInputs */

const en_chat_error_unavailable = /** @type {(inputs: Chat_Error_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LLM service temporarily unavailable.`)
};

const fr_chat_error_unavailable = /** @type {(inputs: Chat_Error_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Service LLM temporairement indisponible.`)
};

const ms_sg2_chat_error_unavailable = /** @type {(inputs: Chat_Error_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Servis LLM tidak tersedia buat sementara waktu.`)
};

/**
* | output |
* | --- |
* | "LLM service temporarily unavailable." |
*
* @param {Chat_Error_UnavailableInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const chat_error_unavailable = /** @type {((inputs?: Chat_Error_UnavailableInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Error_UnavailableInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_chat_error_unavailable(inputs)
	if (locale === "fr") return fr_chat_error_unavailable(inputs)
	return ms_sg2_chat_error_unavailable(inputs)
});